export default __webpack_public_path__ + "static/media/frame3.e66b7c11.webp";